module.exports = __webpack_public_path__ + "1f50fd5bd4be0898b164a4c868b02d9f.png";